import { render, staticRenderFns } from "./bs-col.vue?vue&type=template&id=b4196cf2"
import script from "./bs-col.vue?vue&type=script&lang=ts"
export * from "./bs-col.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports